import { z } from "zod";
const coachingModelIdSchema = z.enum([
  "opus-4-8-high",
  "opus-4-6-high",
  "gpt-5-6-sol-medium",
  "gpt-5-5-medium"
]);
function asCoachingModelId(id) {
  return coachingModelIdSchema.parse(id);
}
const COACHING_MODEL_OPTIONS = [
  { id: "opus-4-8-high", label: "Opus 4.8 (high)" },
  { id: "opus-4-6-high", label: "Opus 4.6 (high)" },
  { id: "gpt-5-6-sol-medium", label: "GPT-5.6 Sol (medium)" },
  { id: "gpt-5-5-medium", label: "GPT-5.5 (medium)" }
];
const DEFAULT_COACHING_MODEL_ID = "opus-4-6-high";
function getCoachingModelLabel(id) {
  return COACHING_MODEL_OPTIONS.find((option) => option.id === id)?.label ?? id;
}
export {
  COACHING_MODEL_OPTIONS,
  DEFAULT_COACHING_MODEL_ID,
  asCoachingModelId,
  coachingModelIdSchema,
  getCoachingModelLabel
};
//# sourceMappingURL=playbookCoachingModel.js.map
